import React, { useEffect, useState } from "react";
import Logo from "../img/xapiens-logo.png";
import { Button, Image, Nav, Navbar } from "react-bootstrap";
import { BsBell } from "react-icons/bs";
import { BiLogOut } from "react-icons/bi";
import { NavLink, Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { logout } from "../redux/actions/loginAction";
import {
  getCurrentStatus,
  getLengthTaskList,
} from "../redux/actions/plannerAction";

import { NotificationContainer } from "react-notifications";

import { createNotificationPlanner } from "./Notification.component";
import { useQuery } from "@apollo/client";
import { GET_TASK_PLANNER } from "../graphql/queries";
import { LinearProgress } from "@material-ui/core";

const NavigationBar = ({
  logout,
  notPlanner,
  lengthTaskList,
  getLengthTaskList,
  getCurrentStatus,
  currentStatus,
}) => {
  const { data, loading, error } = useQuery(GET_TASK_PLANNER, {
    pollInterval: 1000,
  }); // TODOS: GET ALL TASK PLANNER

  const [isNotif, setNotif] = useState(false);

  const [expanded, setExpanded] = useState(false);

  const history = useHistory();

  if (loading) return <LinearProgress />;

  // const getLengthTask = data.findAllTaskPlanner.length // TODOS: GET LENGTH ALL TASK PLANNER

  // const checkLengthTask = () => {
  //   getLengthTaskList(getLengthTask);
  //   lengthTaskList !== getLengthTask ? setNotif(true) : setNotif(false);
  // }

  // checkLengthTask()

  return (
    <div className="navbar-section">
      <Navbar bg="light" expand="lg" sticky="top" expanded={expanded}>
        <Nav.Link
          as={Link}
          to="/dashboard/planner"
          onClick={() => setExpanded(false)}
        >
          <Image src={Logo} fluid />
        </Nav.Link>
        
          <Nav className="mr-auto" />
          {!notPlanner ? (
            <>
              <Nav.Link
                className="mx-2"
                as={Link}
                to="/dashboard/supervisor"
                onClick={() => setExpanded(false)}
              >
                Main Menu
              </Nav.Link>
              <Nav.Link
                className="mx-2"
                as={Link}
                to="/dashboard/supervisor/project-list"
                onClick={() => setExpanded(false)}
              >
                Pending Project
              </Nav.Link>
              <Nav.Link
                className="mx-2"
                as={Link}
                to="/dashboard/supervisor/task-list"
                onClick={() => setExpanded(false)}
              >
                Task List
              </Nav.Link>
            </>
          ) : (
            ""
          )}

          <Button
            className="icon-button mr-sm-2 rounded-circle"
            variant="outline-primary"
            onClick={isNotif && createNotificationPlanner("info")}
          >
            <BsBell />
          </Button>
          <Button
            className="icon-button mr-sm-2 rounded-circle"
            variant="outline-danger"
            onClick={() => {
              logout();
              history.push("/");
              window.location.reload();
            }}
          >
            <BiLogOut />
          </Button>
      </Navbar>
      <NotificationContainer />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currentStatus: state.planner.getCurrentStatus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // getLengthTaskList: (inputTaskList) =>
    //   dispatch(getLengthTaskList(inputTaskList)),
    logout: () => dispatch(logout()),
    getCurrentStatus: (currentStatusArr) =>
      dispatch(getCurrentStatus(currentStatusArr)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavigationBar);
